<template>
    <AdminLayout v-bind="appSharedData.getAdminLayoutProps(pageMeta)">
        <div class="mb-4">
            <form
                method="GET"
                :action="RoutePathAppEnum.Admin_Users"
            >
                <div class="grid grid-cols-12 gap-2">
                    <div class="col-span-12 lg:col-span-3">
                        <TextInput
                            :name="RequestQueryKeyEnum.Admin_Users_Search"
                            :value="searchFilters.search"
                        />
                    </div>
                    <div class="col-span-12 lg:col-span-1">
                        <Button
                            type="submit"
                            iconName="zoom"
                            color="light"
                        >
                            Search
                        </Button>
                    </div>
                </div>
            </form>
        </div>

        <Table>
            <TableHead>
                <TableHeadCell>ID</TableHeadCell>
                <TableHeadCell>Company ID</TableHeadCell>
                <TableHeadCell>Email</TableHeadCell>
                <TableHeadCell>Name</TableHeadCell>
                <TableHeadCell>Role</TableHeadCell>
                <TableHeadCell>Deleted</TableHeadCell>
                <TableHeadCell></TableHeadCell>
            </TableHead>
            <TableBody>
                <template
                    v-for="companyUserAggregate in localCompanyUserAggregates"
                    :key="companyUserAggregate.user.id.value"
                    :user="companyUserAggregate.user"
                >
                    <TableBodyRow>
                        <TableBodyRowCell>
                            {{ companyUserAggregate.companyUser.id.value }}
                        </TableBodyRowCell>
                        <TableBodyRowCell>
                            {{
                                companyUserAggregate.companyUser.companyId.value
                            }}
                        </TableBodyRowCell>
                        <TableBodyRowCell>
                            {{ companyUserAggregate.user.email }}
                        </TableBodyRowCell>
                        <TableBodyRowCell>
                            {{ companyUserAggregate.user.firstName }}
                            {{ companyUserAggregate.user.lastName }}
                        </TableBodyRowCell>
                        <TableBodyRowCell>
                            {{ companyUserAggregate.companyUser.role }}
                        </TableBodyRowCell>
                        <TableBodyRowCell>
                            {{
                                companyUserAggregate.companyUser.isDeleted
                                    ? 'Yes'
                                    : 'No'
                            }}
                        </TableBodyRowCell>
                        <TableBodyRowCell>
                            <div class="flex justify-end items-center gap-1">
                                <form
                                    method="POST"
                                    :action="
                                        urlFactory.makeAdminUsersImpersonationStoreUrl(
                                            companyUserAggregate.companyUser.id,
                                        )
                                    "
                                    :id="`impersonate-company-user-${companyUserAggregate.companyUser.id.value}`"
                                >
                                    <Button
                                        :form="`impersonate-company-user-${companyUserAggregate.companyUser.id.value}`"
                                        color="light"
                                        iconName="user-secret"
                                        size="small"
                                    ></Button>
                                </form>
                            </div>
                        </TableBodyRowCell>
                    </TableBodyRow>
                </template>
            </TableBody>
        </Table>

        <Pagination
            :searchResults="paginatedCompanyUsersData"
            :url="getBasePaginationUrl()"
        />
    </AdminLayout>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import AdminLayout from '@/Shared/Layout/Admin/AdminLayout.vue'
    import Button from '@/Shared/Component/Button.vue'
    import Table from '@/Shared/Component/Table/Table.vue'
    import TableHead from '@/Shared/Component/Table/TableHead.vue'
    import TableHeadCell from '@/Shared/Component/Table/TableHeadCell.vue'
    import TableBody from '@/Shared/Component/Table/TableBody.vue'
    import TableBodyRow from '@/Shared/Component/Table/TableBodyRow.vue'
    import TableBodyRowCell from '@/Shared/Component/Table/TableBodyRowCell.vue'
    import CompanyUserAggregate from '@/App/CompanyUser/Entity/CompanyUserAggregate'
    import Pagination from '@/Shared/Component/Pagination.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import {
        type AdminUserSearchFiltersType,
        type PaginatedResultsType,
    } from '@/Shared/AutoGenerated/Main'
    import type { PageMeta } from '@/Shared/AutoGenerated/Main'
    import AppSharedData from '@/Shared/Entity/AppSharedData'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'
    import { RequestQueryKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'
    import { UrlFactory } from '@/Shared/Url/UrlFactory'

    interface IndexUsersProps {
        pageMeta: PageMeta
        appSharedDataData: any
        paginatedCompanyUsersData: PaginatedResultsType
        searchFilters: AdminUserSearchFiltersType
    }

    const props = defineProps<IndexUsersProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
    const urlFactory = new UrlFactory()

    const getBasePaginationUrl = (): string => {
        return urlFactory.makeAdminUsersPageUrl(props.searchFilters.search)
    }

    const localCompanyUserAggregates = ref<CompanyUserAggregate[]>(
        CompanyUserAggregate.hydrateMultiple(
            props.paginatedCompanyUsersData.records,
        ),
    )
</script>
